/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "settingshub": {
        "nested": {
          "model": {
            "nested": {
              "Scope": {
                "values": {
                  "SCOPE_UNDEFINED": 0,
                  "SCOPE_DEVICE": 1,
                  "SCOPE_LOCATION": 2,
                  "SCOPE_MERCHANT": 3,
                  "SCOPE_SALES_CHANNEL": 4,
                  "SCOPE_FULFILLMENT_METHOD": 5,
                  "SCOPE_OVERRIDE": 6,
                  "SCOPE_DEVICE_PROFILE": 7,
                  "SCOPE_ENVIRONMENT": 8,
                  "SCOPE_REGION": 9,
                  "SCOPE_APPLICATION": 10
                }
              },
              "ScopeId": {
                "fields": {
                  "scope": {
                    "type": ".squareup.settingshub.model.Scope",
                    "id": 1,
                    "rule": "optional"
                  },
                  "id": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "ScopeKey": {
                "fields": {
                  "scopeIds": {
                    "type": ".squareup.settingshub.model.ScopeId",
                    "id": 1,
                    "rule": "repeated"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.settingshub?.nested?.model?.nested?.Scope && !$root.nested?.squareup?.nested?.settingshub?.nested?.model?.nested?.ScopeId && !$root.nested?.squareup?.nested?.settingshub?.nested?.model?.nested?.ScopeKey) {
  $root.addJSON(jsonData);
}

/**
 * Global scope definition for the Settings Hub.
 *
 * This enum defines the hierarchical scope levels at which configuration settings
 * can be applied, both individually and in combinations (intersections).
 *
 * SOURCE Scope @ squareup/settingshub/model/scope.proto at 17:1
 */
export const Scope = $root.lookupEnum('squareup.settingshub.model.Scope').values;
/**
 * Identifies a specific entity at a scope level
 *
 * SOURCE ScopeId @ squareup/settingshub/model/scope.proto at 90:1
 */
export const ScopeId = $root.lookupType('squareup.settingshub.model.ScopeId');
fixType(ScopeId, {
  scope: {
    required: true
  }
});
Builder.createAndAttachToType(ScopeId);
/**
 * Identifies a scope key - can be a single scope or multiple scopes (intersection).
 *
 * Examples:
 *
 * Single scope (location settings):
 * scope_ids: [
 *   ScopeId(scope=LOCATION, id="L123")
 * ]
 *
 * Intersectional scope (channel-specific location settings):
 * scope_ids: [
 *   ScopeId(scope=CHANNEL, id="DoorDash"),
 *   ScopeId(scope=LOCATION, id="L123")
 * ]
 * → Server generates composite ID: "DoorDash-L123"
 *
 * SOURCE ScopeKey @ squareup/settingshub/model/scope.proto at 115:1
 */
export const ScopeKey = $root.lookupType('squareup.settingshub.model.ScopeKey');
fixType(ScopeKey);
Builder.createAndAttachToType(ScopeKey);